import Notification from 'components/Notification';
import { APIWrapper, LeftColumn, RightColumn } from 'components/ApiRef';
import CodeSnippet from 'components/CodeSnippet';
import Link from 'components/Link';
import * as CODE from "../../../../src/constants/personal-data";
import Helmet from 'react-helmet';
import * as React from 'react';
export default {
  Notification,
  APIWrapper,
  LeftColumn,
  RightColumn,
  CodeSnippet,
  Link,
  CODE,
  Helmet,
  React
};